import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M5 2H3.8v12.467L0 10.668v1.697l4.4 4.4L9 12.164v-1.696l-4 4V2zm8.6-.765L9 5.836v1.696l4-4V16h1.2V3.533L18 7.332V5.635l-4.4-4.4z" />
  </svg>
);

export default SvgComponent;
